module.exports = __webpack_public_path__ + "static/media/YW.c00863b0.svg";